import { render } from "./ProofPage.vue?vue&type=template&id=b54d5d12&scoped=true"
import script from "./ProofPage.vue?vue&type=script&lang=js"
export * from "./ProofPage.vue?vue&type=script&lang=js"

import "./ProofPage.vue?vue&type=style&index=0&id=b54d5d12&scoped=true&lang=css"

import exportComponent from "/Users/li/Golang/supergroup.mixin.one/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b54d5d12"]])

export default __exports__